import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { BookingSummaryCard } from './BookingSummaryCard';
import { getUserFacingBookingId } from '../../utils/userFacingBookingId';

export function CollapsibleBookingPanel({
  booking,
  snap,
  bookingId,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const label = getUserFacingBookingId({ booking_id: bookingId, ...(booking || {}) });

  return (
    <div className="bg-white border border-gray-200 rounded-xl mb-3 overflow-hidden" data-testid="collapsible-booking-panel">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left hover:bg-gray-50"
        data-testid="collapsible-booking-toggle"
      >
        <div>
          <div className="text-[10px] text-gray-500 uppercase tracking-wide">Booking</div>
          <div className="font-mono text-sm font-semibold text-[#1B375B]">{label}</div>
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-gray-500" /> : <ChevronDown className="w-4 h-4 text-gray-500" />}
      </button>
      {open && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <BookingSummaryCard
            booking={booking}
            snap={snap}
            bookingId={bookingId}
            className="!mb-0 border-0 !p-0"
          />
        </div>
      )}
    </div>
  );
}

export default CollapsibleBookingPanel;
